module.exports = "<p>\r\n  my-booking works!\r\n</p>\r\n"